module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/submission/components/delete-submission-confirmation-dialog.component.scss
// module id = ./src/app/submission/components/delete-submission-confirmation-dialog.component.scss
// module chunks = main